import { LOYALTY_STATUS_LIST } from './constants';
import { type User } from './User';

type LoyaltyPoints = {
  actual?: number;
  season?: {
    balance: number;
    toExpire: number;
    expireAt: string;
  };
  toExpire?: number;
  expireAt?: string;
};

export type LoyaltyProfileData = {
  name: string;
  picture: string | null;
  points: LoyaltyPoints;
  status: number;
  hasArchitectCashback: boolean;
};

export type UserEligibleData = {
  id: string;
  isLoggedIn: boolean;
  isAssistedSale: boolean;
  isLegalUser: boolean;
};

export class LoyaltyProfile {
  constructor(
    private readonly user: UserEligibleData,
    private readonly data: LoyaltyProfileData
  ) {}

  static isEligible(user: UserEligibleData) {
    return Boolean(
      user.isLoggedIn && !user.isAssistedSale && !user.isLegalUser
    );
  }

  static userEligibleDataSelector(data: User): UserEligibleData {
    return {
      id: data.id,
      isLoggedIn: data.isLoggedIn,
      isAssistedSale: data.isAssistedSale,
      isLegalUser: data.isLegalUser,
    };
  }

  get name() {
    return this.data.name;
  }

  get picture() {
    return this.data.picture;
  }

  get points() {
    return this.data.points;
  }

  get status() {
    return this.data.status;
  }

  get hasArchitectCashback() {
    return this.data.hasArchitectCashback;
  }

  get isMember() {
    return [
      LOYALTY_STATUS_LIST.ACTIVE,
      LOYALTY_STATUS_LIST.PRO_EXECUTOR_ACTIVE,
      LOYALTY_STATUS_LIST.PRO_EAD_ACTIVE,
      LOYALTY_STATUS_LIST.PRO_EAD_WAITING_DOCUMENTATION_VALIDATION,
      LOYALTY_STATUS_LIST.PRO_EAD_WITHOUT_DOCUMENTATION,
      LOYALTY_STATUS_LIST.PRO_EAD_DOCUMENTATION_DENIED,
    ].some((status) => status === this.status);
  }

  get isProEAD() {
    return [
      LOYALTY_STATUS_LIST.PRO_EAD_ACTIVE,
      LOYALTY_STATUS_LIST.PRO_EAD_WAITING_DOCUMENTATION_VALIDATION,
      LOYALTY_STATUS_LIST.PRO_EAD_WITHOUT_DOCUMENTATION,
      LOYALTY_STATUS_LIST.PRO_EAD_DOCUMENTATION_DENIED,
    ].some((status) => status === this.status);
  }

  get isEligible() {
    return LoyaltyProfile.isEligible(this.user);
  }
}
